export default Object.freeze({
  RUNS: "/client-summary-validation",
  RUN_DETAIL: "/client-summary-validation/run",
});
